<template>
  <aha-modal
    actionPosition="justify-end"
    :title="'Present to audience'"
    @hide="$emit('hide')"
  >
    <p class="mb-2">
      {{ $i18nPresenter.t('Share this screen to show your slides to the audience.') }}
    </p>
    <img class="m-auto block" src="@/assets/images/ms-teams/firstGuide.png" />
    <div class="block text-right p-2">
      <aha-button
        variant="primary"
        @click="$emit('hide')"
      >
        {{ $i18nPresenter.t('Got it') }}
      </aha-button>
    </div>
  </aha-modal>
</template>

<script>
export default {
  name: 'MSTeamsSharingGuideModal',
}
</script>
